import { Overlay } from "../types";
import { GEOSERVER_URL } from "src/environments/environment.prod";
import { GEOSERVER_WORKSPACE } from "./geoserver.constant";

const createWMSLayer = (map, url, options, uniqueId) => {
  const { layers, format, transparent, attribution } = options;

  const sourceId = `${uniqueId}-overlay-source`;
  const layerId = `${uniqueId}-overlay-layer`;

  map.addSource(sourceId, {
    type: 'raster',
    tiles: [
      `${url}?service=WMS&version=1.3.0&request=GetMap&layers=${layers}&styles=&bbox={bbox-epsg-3857}&width=750&height=768&srs=EPSG:3857&format=${format}&transparent=${transparent}`
    ]
  });

  map.addLayer({
    id: layerId,
    type: 'raster',
    source: sourceId
  });
};

export const MOD_VISUALIZATION_OVERLAYS: Overlay[] = [
  {
    id: 'Comunidades',
    layers: `${GEOSERVER_WORKSPACE}:mv_community_info_new_5`,
    name: 'Comunidades',
    source: 'Povos da Floresta',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=mv_community_info_new_5&outputFormat=SHAPE-ZIP&format_options=filename:Comunidades.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:mv_community_info_new_5`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  },
  {
    id: 'states',
    layers: `${GEOSERVER_WORKSPACE}:geo_states`,
    name: 'Estados',
    source: 'IBGE',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geo_states&outputFormat=SHAPE-ZIP&format_options=filename:Estados.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:geo_states`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  },
  {
    id: 'municipalities',
    layers: `${GEOSERVER_WORKSPACE}:geo_municipalities`,
    name: 'Municípios',
    source: 'IBGE',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geo_municipalities&outputFormat=SHAPE-ZIP&format_options=filename:Municípios.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:geo_municipalities`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  },
  {
    id: 'indigenous_lands',
    layers: `${GEOSERVER_WORKSPACE}:geo_indigenous_land`,
    name: 'Terras Indígenas',
    source: 'INCRA',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geo_indigenous_land&outputFormat=SHAPE-ZIP&format_options=filename:Terras_Indígenas.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:geo_indigenous_land`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  },
  {
    id: 'uc',
    layers: `${GEOSERVER_WORKSPACE}:geo_conservation_unit`,
    name: 'Unidades de Conservação',
    source: 'MMA',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geo_conservation_unit&outputFormat=SHAPE-ZIP&format_options=filename:Unidades_de_Conservação.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:geo_conservation_unit`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  },
  {
    id: 'quilombo',
    layers: `${GEOSERVER_WORKSPACE}:geo_quilombo`,
    name: 'Quilombos',
    source: 'IBGE/Povos da Floresta/INCRA',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geo_quilombo&outputFormat=SHAPE-ZIP&format_options=filename:Quilombos.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:geo_quilombo`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  },
  {
    id: 'settlement',
    layers: `${GEOSERVER_WORKSPACE}:geo_settlement`,
    name: 'Assentamentos',
    source: 'INCRA',
    year: 'TEST',
    downloadUrl: `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geo_settlement&outputFormat=SHAPE-ZIP&format_options=filename:Assentamentos.zip`,
    layer: (map, uniqueId) => createWMSLayer(map, `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wms`, {
      layers: `${GEOSERVER_WORKSPACE}:geo_settlement`,
      format: 'image/png',
      transparent: true
    }, uniqueId)
  }
];
